import React, { useEffect, createElement } from 'react';
import { SalesPage } from './components/SalesPage';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    // Meta Pixel manual injection
    const pixelId = '26164957323164507';
    // Initialize fbq
    if (!(window as any).fbq) {
      const n = ((window as any).fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      }) as any;
      if (!(window as any)._fbq) (window as any)._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
    }
    ;
    (window as any).fbq('init', pixelId);
    (window as any).fbq('track', 'PageView');
    // Load the pixel script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
  }, []);
  return <>
      <SalesPage data-id="element-0" />
      <SocialProofPopup data-id="element-1" />
    </>;
}